import Welcome from "./components/Welcome";
import { ReactComponent as ArrowLeft } from "images/arrow_left.svg";
import { ReactComponent as MainLogoIcon } from "images/main-logo.svg";
import { useEffect, useState } from "react";
import "./style.css";
import CreateAccount from "./components/CreateAccount";
import { ReactComponent as FrameBack } from "images/frame_back.svg";
import queryString from "querystring";
import { useLocation, useNavigate } from "react-router-dom";
import LanguageSelector, { LANGUAGES } from "../../components/LanguageSelector";
import TalaeraRoutes from "components/routes/TalaeraRoutes";
import i18n from "i18n";

const STEP = {
  welcome: 1,
  createAccount: 2,
};

function SignUpByInvitation() {
  const location = useLocation();
  const query = queryString.parse(location.search);
  const [step, setStep] = useState(query.consumer === "true" ? 2 : 1);
  const navigate = useNavigate();

  const [lang, setLang] = useState(LANGUAGES[0].value);

  const handlePreviousStep = () => {
    if (step !== STEP.welcome) {
      setStep(prev => prev - 1);
    }
  };

  const handleNextStep = () => {
    if (step === STEP.welcome) {
      setStep(STEP.createAccount);
    } else {
      navigate(TalaeraRoutes.ROOT.path);
    }
  };

  const hdSelect = (value: string) => setLang(value);

  const uiLanguage = navigator.language;
  useEffect(() => {
    let supportedLanguages = LANGUAGES.map(v => v.value);

    if (i18n.language !== uiLanguage) {
      let changeValue = supportedLanguages.includes(uiLanguage) ? uiLanguage : "en";
      i18n.changeLanguage(changeValue).then(() => {
        setLang(changeValue);
      });
    }
  }, [uiLanguage]);

  return (
    <div className={"sign-up-by-invitation-page"}>
      <div className={"sign-up-by-invitation container"}>
        <div className="header">
          <div
            className={"previous-step"}
            onClick={handlePreviousStep}
            style={{
              visibility: step !== STEP.welcome ? "visible" : "hidden",
            }}
          >
            <ArrowLeft />
          </div>
          <MainLogoIcon className="signup-logo" />
          <LanguageSelector
            color={"black"}
            className={"language-btn"}
            onSelect={hdSelect}
            value={lang}
          />
        </div>

        <div className="progress-bar">
          <div className="progress-inner" />
        </div>

        {step === STEP.welcome && <Welcome query={query} onNextStep={handleNextStep} />}

        {step === STEP.createAccount && (
          <CreateAccount location={location} onNextStep={handleNextStep} />
        )}
      </div>

      {step === STEP.welcome && <FrameBack className="frame-back" />}
    </div>
  );
}

export default SignUpByInvitation;
